import { render, staticRenderFns } from "./XMLStep.vue?vue&type=template&id=80a0a342"
import script from "./XMLStep.vue?vue&type=script&lang=js"
export * from "./XMLStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports